<template>
  <div v-if="isShow" class="toast-wrapper">
    <div class="toast">
      <div class="text">{{ msg && msg.length ? msg : '正在加载中...' }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['isShow', 'msg']
}
</script>
<style lang="less" scoped>
@import '../assets/styles/common/_util.less';
@import '../assets/styles/common/fs';

.toast-wrapper {
  position: fixed;
  .fs-pos(0,0,0,0);
  z-index: 10000;
  .toast {
    position: absolute;
    .fs(28);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .fs-radius(8);
    color: #fff;
    .fs-line-height(40);
    .fs-min-width(200);
    .fs-padding(30, 25, 30, 25);
    text-align: center;
    background-color: rgba(30, 30, 30, .8);
  }
}
  
</style>


// WEBPACK FOOTER //
// toast.vue?91063818